import { useTranslation } from '@repo/roche-xx-shared';
import { RocheUILoadingSpinner } from '@rocheglobal/roche-ui';
import React from 'react';

/**
 * Internal use only, not a Storyblok component
 * @constructor
 */
export const RocheLoadingSpinner = () => {
  const loadingTranslation = useTranslation('loading');
  return <RocheUILoadingSpinner loadingText={loadingTranslation} />;
};
